import React from "react";
import { IconT } from "types/utils";
import { theme } from "styles/themes";

const InfoCircleIcon = ({
  width = "20",
  height = "20",
  stroke = theme.colors["nepal-blue"],
  fill = theme.colors.white,
}: IconT) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_287_207)">
        <path
          d="M10 13.3333V10M10 6.66666H10.0084M18.3334 10C18.3334 14.6024 14.6024 18.3333 10 18.3333C5.39765 18.3333 1.66669 14.6024 1.66669 10C1.66669 5.39762 5.39765 1.66666 10 1.66666C14.6024 1.66666 18.3334 5.39762 18.3334 10Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_287_207">
          <rect width={+width + 2} height={+height + 2} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InfoCircleIcon;
